import api from "./Api";

class GerenciadorCTeService {
  PadroesDisponiveis() {
    return api.get("/v1/GerenciadorCTe/PadroesDisponiveis").then((response) => {
      return response.data;
    });
  }

  TransmitirNota(payload) {
    return api
      .get("/v1/GerenciadorCTe/TransmitirNota?nota=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ConsultarNota(payload) {
    const nota = typeof payload === "object" ? payload.id : payload;

    return api
      .get("/v1/GerenciadorCTe/ConsultarNota?nota=" + nota)
      .then((response) => {
        return response.data;
      });
  }

  CancelarNota(payload) {
    return api
      .put("/v1/GerenciadorCTe/CancelarNota?nota=" + payload.id, {
        justificativa: payload.justificativa,
      })
      .then((response) => {
        return response.data;
      });
  }

  ImprimirNota(payload) {
    return api
      .get("/v1/GerenciadorCTe/ImprimirNota/" + payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
  }

  PreVisualizarNota(payload) {
    return api
      .get("/v1/GerenciadorCTe/PreVisualizarNota/" + payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
  }

  DownloadXMLCTe(payload) {
    return api
      .get("/v1/GerenciadorCTe/DownloadXMLCTe?id=" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new GerenciadorCTeService();
